import LegalLayout from "./LegalLayout";

const CONTACT = "besoindunpro@gmail.com";

export default function Privacy() {
  return (
    <LegalLayout slug="privacy">
      <section>
        <h2 className="font-heading font-bold text-xl mt-2 mb-3">1. Responsable du traitement</h2>
        <p>
          La présente politique s&apos;applique à l&apos;application mobile et au site web
          <strong> Besoin d&apos;un Pro&nbsp;?</strong>. Pour toute question relative à vos données
          personnelles, contactez-nous à&nbsp;
          <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a>.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">2. Données que nous collectons</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Informations de compte</strong>&nbsp;: nom/prénom, adresse email, mot de passe
            (chiffré avec bcrypt). Si vous utilisez la connexion Google, nous recevons votre nom,
            email et photo de profil.
          </li>
          <li>
            <strong>Rôle</strong>&nbsp;: particulier ou professionnel (artisan).
          </li>
          <li>
            <strong>Données professionnelles (artisans uniquement)</strong>&nbsp;: numéro SIRET,
            métier, ville d&apos;intervention, certifications (RGE), avis reçus. Le SIRET est vérifié
            via l&apos;API publique SIRENE (INSEE) et le RGE via l&apos;API publique ADEME.
          </li>
          <li>
            <strong>Localisation</strong>&nbsp;: ville et coordonnées géographiques
            (latitude/longitude à la précision de la ville) pour proposer des mises en relation locales.
          </li>
          <li>
            <strong>Demandes de travaux</strong>&nbsp;: titre, description, métier, urgence, budget.
          </li>
          <li>
            <strong>Messagerie</strong>&nbsp;: messages échangés entre utilisateurs après déblocage
            d&apos;un lead.
          </li>
          <li>
            <strong>Données techniques</strong>&nbsp;: identifiants de session, données d&apos;usage
            anonymisées (analytics), jetons de notification push.
          </li>
          <li>
            <strong>Achats</strong>&nbsp;: statut d&apos;abonnement Premium, historique de jetons
            achetés. Les paiements sont gérés par Mollie (web) ou Google Play Billing (application
            Android)&nbsp;; <strong>nous ne stockons aucune donnée de carte bancaire.</strong>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">3. Comment nous utilisons vos données</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Mettre en relation les particuliers et les artisans localement.</li>
          <li>Vérifier l&apos;identité professionnelle (SIRET, RGE).</li>
          <li>Faire fonctionner la messagerie, les notifications et l&apos;abonnement Premium.</li>
          <li>Améliorer et sécuriser le service (statistiques d&apos;audience anonymisées).</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">4. Partage et services tiers</h2>
        <p>
          <strong>Nous ne vendons jamais vos données.</strong> Nous faisons appel à des prestataires
          strictement nécessaires au fonctionnement&nbsp;:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Google</strong> (Connexion Google, Google Play Billing, Google Analytics)&nbsp;:
            authentification sociale, paiements (application Android) et mesure d&apos;audience.
          </li>
          <li>
            <strong>Mollie B.V.</strong>&nbsp;: paiements sur la version web (établissement de
            paiement européen agréé).
          </li>
          <li>
            <strong>INSEE</strong> (API SIRENE) et <strong>ADEME</strong> (API RGE)&nbsp;: vérification
            d&apos;informations professionnelles publiques.
          </li>
          <li>Autorités légales uniquement si la loi l&apos;exige.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">5. Durée de conservation</h2>
        <div className="overflow-x-auto my-3">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-white border-b border-border">
                <th className="text-left p-2 font-semibold">Type de données</th>
                <th className="text-left p-2 font-semibold">Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-border/50">
                <td className="p-2">Compte et profil (particulier ou pro)</td>
                <td className="p-2">Tant que votre compte est actif</td>
              </tr>
              <tr className="border-b border-border/50">
                <td className="p-2">Demandes, devis, messages</td>
                <td className="p-2">Tant que votre compte est actif</td>
              </tr>
              <tr className="border-b border-border/50">
                <td className="p-2">Comptes inactifs</td>
                <td className="p-2">Supprimés automatiquement après 24 mois d&apos;inactivité</td>
              </tr>
              <tr className="border-b border-border/50">
                <td className="p-2">Après suppression du compte</td>
                <td className="p-2">Effacement <strong>immédiat</strong> des bases actives, purge des sauvegardes sous <strong>30 jours</strong> maximum</td>
              </tr>
              <tr>
                <td className="p-2">Données de facturation légales</td>
                <td className="p-2">Conservées le temps requis par la loi, puis supprimées. Aucune donnée de paiement n&apos;est stockée par nous.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">6. Comment supprimer vos données (droit à l&apos;effacement)</h2>
        <p>
          Vous pouvez supprimer votre compte et <strong>toutes</strong> les données associées à tout
          moment&nbsp;:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Dans l&apos;application</strong>&nbsp;: <em>Profil → Supprimer le compte</em>. La
            suppression est <strong>immédiate</strong>.
          </li>
          <li>
            <strong>Par e-mail</strong>&nbsp;: écrivez à&nbsp;
            <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a> avec l&apos;objet
            «&nbsp;Suppression de compte&nbsp;». Nous traitons la demande sous 30 jours maximum.
          </li>
        </ul>
        <p>
          Détails complets&nbsp;:&nbsp;
          <a href="/legal/data-deletion" className="text-brand">page de suppression des données</a>.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">7. Sécurité</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Chiffrement SSL/TLS de toutes les communications.</li>
          <li>Mots de passe hachés (bcrypt) ; authentification par jetons JWT.</li>
          <li>Accès restreint et contrôlé aux bases de données.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">8. Vos droits (RGPD)</h2>
        <p>
          Vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de
          portabilité, d&apos;opposition et de limitation. Pour exercer ces droits&nbsp;:&nbsp;
          <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a>.
        </p>
        <p>
          Vous pouvez également introduire une réclamation auprès de la&nbsp;
          <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noreferrer" className="text-brand">
            CNIL
          </a>.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">9. Enfants</h2>
        <p>
          Besoin d&apos;un Pro&nbsp;? n&apos;est pas destinée aux personnes de moins de 16 ans. Nous
          ne collectons pas sciemment leurs données.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">10. Modifications</h2>
        <p>
          Cette politique peut être mise à jour. Toute modification importante sera signalée dans
          l&apos;application et la date de mise à jour ci-dessus sera actualisée.
        </p>
      </section>

      <section>
        <h2 className="font-heading font-bold text-xl mt-6 mb-3">11. Contact</h2>
        <p>
          E-mail&nbsp;: <a href={`mailto:${CONTACT}`} className="text-brand">{CONTACT}</a>
        </p>
      </section>
    </LegalLayout>
  );
}
